import { css } from 'linaria';

export const pdpPageWarningMessageWrapper = css`
  margin-top: var(--space-150);
  @media (--only-mobile) {
    margin-top: var(--space-200);
  }
`;
